import { Component, OnInit, Input, Output, EventEmitter,ViewChild, SimpleChanges, OnChanges, HostListener } from '@angular/core';
import { AuthService } from 'core';
import { ProjectService } from '../../services/project.service';
import { AlertifyService } from '../../services/alertify.service';
import { timeout } from 'rxjs';
@Component({
  selector: 'or-launch-confirmation',
  templateUrl: './launch-confirmation.component.html',
  styleUrls: ['./launch-confirmation.component.scss']
})
export class LaunchConfirmationComponent implements OnInit {

  @Input() values = ['Test', 'Soft Launch', 'Full Launch', 'Paused', 'Closed', 'Invoiced'];
  @Input() projectId: string;
  @Input() partnerId: string;
  @Input() partnerName: string;
  @Input() status: string;

  @Output() saved = new EventEmitter();
  @Output() close = new EventEmitter();

  details: any = null;
  gettingDetails = false;
  loadingLaunch = false;

  cleanIdThresholds = { '1000': 'No Threshold', '30': 'Conservative (30)', '25': 'Moderate (25)', '20': 'Aggressive (20)', '-2': 'Vendor Based', '-1': 'Using API' };
  cleanIdThresholdTooltipMsg = `<span>Aggressive (20): Allows only traffic with no fraud signals.<br>
            Moderate (25): Default. Balances fraud control and volume.<br>
            Conservative (30): Looser filter. Use only with trusted vendors.<br>
            No Threshold: No blocking based on CleanID score.<br>
            Vendor Based: Uses each vendor's profile threshold.</span>`

  constructor( private projectService: ProjectService,
    private alertify: AlertifyService,
    public auth: AuthService
  ) { }

  ngOnInit() {
    this.getProjectDetailsForLaunchConfirmation();
  }

  getProjectDetailsForLaunchConfirmation() {
    this.gettingDetails = true;
    this.projectService.GetProjectForLaunchConfirmation(this.projectId).subscribe(projectDetails => {
      if (projectDetails != null) {
        this.details = projectDetails;
        this.details.status = this.status;
        this.details.partnerId = this.partnerId;
        this.details.originalProjectFieldLimitEnabled = projectDetails.projectFieldLimitEnabled;
        this.details.originalSurveyLink = projectDetails.surveyLink;
        this.details.fieldStartDate = projectDetails.fieldStartDate ? new Date(projectDetails.fieldStartDate) : null;
        this.details.fieldEndDate = projectDetails.fieldEndDate ? new Date(projectDetails.fieldEndDate) : null;
        this.details.originalFieldStartDate = projectDetails.fieldStartDate;
        this.details.originalFieldEndDate = projectDetails.fieldEndDate;
        this.details.projectFieldLimitEnabled = true;
        this.details.canLaunch = false;
        
        this.gettingDetails = false;
      }
      else {
        this.alertify.error('There was an issue getting the details for launch confirmation');
        this.gettingDetails = false;
      }
      this.checkCanLaunch();
    }, error => {
      this.alertify.error('There was an issue getting the details for launch confirmation');
      this.gettingDetails = false;
    });
  }

  checkCanLaunch() {
    if (this.details.surveyLink.trim() === '' ||
        this.details.fieldStartDate == 'Invalid Date' ||
        this.details.fieldStartDate == null || 
        this.details.fieldEndDate == 'Invalid Date' ||
        this.details.fieldEndDate == null) {
        
      this.details.canLaunch = false;
    }
    else {
      this.details.canLaunch = true;
    }
  }

  updateStatusAndLaunchDetails(event = null, newValue = null) {
    if (this.loadingLaunch) return;
    this.loadingLaunch = true;

    this.details.fieldStartDate = this.DateAsUTCDate(this.details.fieldStartDate);
    this.details.fieldEndDate = this.DateAsUTCDate(this.details.fieldEndDate);
    this.projectService.LaunchSurvey(this.projectId, this.details).subscribe(result => {
      this.successMessage();
      // gice delay to allow the success message to show before closing the modal
      this.loadingLaunch = false;
      setTimeout(() => {
        this.saved.emit(this.details);
      }, 500);
    }, error => {
      this.loadingLaunch = false;
      this.alertify.error('There was an issue updating the status');
    });
  }
  

  DateAsUTCDate(date) {
    if (date != null) {
      date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12));
    }
    return date;
  }

  successMessage() {
    var successMessage = '';
    var details = this.details;

    successMessage += `${details.status} status applied to `
    if (this.partnerId) {
      if (details.applyToMore) successMessage += 'Overall Project'
      if (this.partnerName) successMessage += ' and to ' + this.partnerName + '.'
      else  successMessage += '.'
    }
    else {
      successMessage += `Overall Project`
      if (details.applyToMore) successMessage += ' and across all vendors.'
    }

    if (this.details.originalSurveyLink.trim() != details.surveyLink.trim()) {
      if (successMessage.length > 0) successMessage += ' '
      successMessage += 'Live URL was updated.'
    }
    var oldFieldStartDate = details?.originalFieldStartDate ? this.DateAsUTCDate(new Date(details.originalFieldStartDate)).toString() : null;
    var oldFieldEndDate = details?.originalFieldEndDate ? this.DateAsUTCDate(new Date(details.originalFieldEndDate)).toString() : null;
    if (oldFieldStartDate !== this.details.fieldStartDate.toString() ||
      oldFieldEndDate !== this.details.fieldEndDate.toString()) {
      if (successMessage.length > 0) successMessage += ' '
      successMessage += 'Field Dates were updated.'
    }
    if (details.originalProjectFieldLimitEnabled != this.details.projectFieldLimitEnabled) {
      if (successMessage.length > 0) successMessage += ' '
      successMessage += `Enforce Limits was turned ${this.details.projectFieldLimitEnabled ? 'on' : 'off'}.`
    }
    this.alertify.success(successMessage);
  }

  cancel() {
    if (this.loadingLaunch) return;
    this.close.emit();
  }

  asIsOrder(a, b) {
    return 1;
  }
}


